/**
 * TODO STE-1605: replace this placeholder header with proper JSDoc and a Storybook story
 * WIP
 */
import React from "react";

import { css, cx } from "@emotion/css";
import { UseHoverProps } from "@floating-ui/react";
import Typography from "@mui/material/Typography";

import { useStyles } from "@/hooks/useStyles.ts";
import { Theme } from "@/theme/CreateTheme.ts";
import { Optional } from "@/utils/commonUtils.ts";

import { TooltipBase, BaseTooltipProps } from "./TooltipBase.tsx";

export type TooltipProps = Omit<Optional<BaseTooltipProps, "role">, "type"> & {
  hover?: UseHoverProps;
};

/**
 * TODO STE-1605 refactor tooltip to be more maintainable
 */
export const Tooltip: React.FC<TooltipProps> = ({
  role = "tooltip",
  hover,
  className,
  floaterClassName,
  wrapperClassName,
  children,
  ...props
}) => {
  const styles = useStyles(makeStyles);

  return (
    <TooltipBase
      type={hover ? { type: "hover", ...hover } : "hover"}
      role={role}
      className={cx(styles.container, className)}
      wrapperClassName={cx(styles.wrapper, wrapperClassName)}
      floaterClassName={cx(styles.floater, floaterClassName)}
      {...props}
    >
      {children}
    </TooltipBase>
  );
};

export type TextTooltipProps = Omit<TooltipProps, "content"> & {
  text: string | undefined;
  textClassName?: string;
};

/**
 * TODO STE-1605 refactor tooltip to be more maintainable
 */
export const TextTooltip: React.FC<TextTooltipProps> = ({ text, children, textClassName, ...props }) => (
  <Tooltip
    content={
      <Typography variant="bodySmall" className={textClassName}>
        {text}
      </Typography>
    }
    {...props}
  >
    {children}
  </Tooltip>
);

const makeStyles = (theme: Theme) => ({
  container: css``,
  wrapper: css``,
  floater: css`
    padding: ${theme.spacing(4)};
  `,
});
